import { render, staticRenderFns } from "./StaticData.vue?vue&type=template&id=47ce2e01&scoped=true&"
import script from "./StaticData.vue?vue&type=script&lang=js&"
export * from "./StaticData.vue?vue&type=script&lang=js&"
import style0 from "./StaticData.vue?vue&type=style&index=0&id=47ce2e01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce2e01",
  null
  
)

export default component.exports